import { render, staticRenderFns } from "./MaskAmount.vue?vue&type=template&id=24e61dca"
import script from "./MaskAmount.vue?vue&type=script&lang=js"
export * from "./MaskAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports